import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  serverTime: 0
};

export const serverDetailsSlice = createSlice({
  name: 'serverDetails',
  initialState,
  reducers: {
    setServerDetails: (state, action) => {
      state.serverTime = action.payload;
    }
  }
});

export const { setServerDetails } = serverDetailsSlice.actions;

export default serverDetailsSlice.reducer;
